// extracted by mini-css-extract-plugin
module.exports = {"carCard":"CarCard_carCard___trFN","header":"CarCard_header__KiiT9","img":"CarCard_img__YnDrL","details":"CarCard_details__Ii1_5","details__title":"CarCard_details__title__s_gxu"};